import Image from "./image";

export default class MicroSites {
  id?: number;
  description: string;
  url: string;
  micro_site_image?: MicroSiteImage;

  constructor(values: MicroSitesConstructorValues) {
    this.id = values.id;
    this.description = values.description;
    this.url = values.url;
    this.micro_site_image = values.micro_site_image;
  }
}

export interface MicroSitesConstructorValues {
  id?: number;
  description: string;
  url: string;
  micro_site_image?: MicroSiteImage;
}

export interface MicroSiteImage {
  id: number;
  micro_site_id: number;
  image_id: number;
  image: Image;
}
